import { SyuugyouJoukenMeijisyoApi } from "@/api/SyuugyouJoukenMeijisyoApi";
import { SyuugyouJoukenMeijisyo } from "@/types/SyuugyouJoukenMeijisyo";

export class SyuugyouJoukenMeijisyoService {
  /**
   * 雇用契約IDを指定して就業条件明示書を取得します
   * @returns システム上の全ての就業場所一覧
   */
  public async findByKoyouKeiyakuId(koyouKeiyakuId: number) {
    const api = new SyuugyouJoukenMeijisyoApi()
    return await api.findByKoyouKeiyakuId(koyouKeiyakuId)
  }

  /**
   * 明示書の作成
   * @returns 当該ユーザーの就業場所一覧
   */
  public async create(req: SyuugyouJoukenMeijisyo) {
    const api = new SyuugyouJoukenMeijisyoApi()
    return await api.create(req)
  }

  /**
   * 明示書の更新
   * @returns 当該ユーザーの就業場所一覧
   */
  public async update(req: SyuugyouJoukenMeijisyo) {
    const api = new SyuugyouJoukenMeijisyoApi()
    return await api.update(req)
  }
}
